;(function ($) {
  $('.join_facebook_modal .later').on('click', function (e) {
    e.preventDefault()
    $.ajax({
      url: '/admin/group_profile/join_facebook_later',
      success: function () {
        $('.join_facebook_modal .js-c-footer-popup__close').click()
      },
    })
  })

  $('.join_facebook_modal .js-c-footer-popup__close').on('click', function (e) {
    e.preventDefault()
    $.ajax({
      url: '/admin/group_profile/join_facebook_later',
      data: {session: true}
    })
  })
})(jQuery)
